import {
  PRICING_MODEL_LABELS,
  toBillingFrequencyLabel
} from '@sequencehq/utils'
import {
  BillingFrequency,
  BillingType,
  PricingModel,
  RevenueRecognitionMethod
} from 'common/drawers/PricingEditor/domain'
import { toRevenueRecognitionMethodLabel } from 'modules/RevenueRecognition'

const pricingModelToLabel = (pricingModel: PricingModel) =>
  PRICING_MODEL_LABELS[pricingModel] ?? 'Not selected'

export const commonPriceDetails = (args: {
  taxCategoryName?: string
  pricingModel: PricingModel
  revenueRecognitionMethod?: RevenueRecognitionMethod
  billingFrequency: BillingFrequency
  billingType: BillingType
}) => {
  return [
    {
      label: 'Pricing model',
      value: pricingModelToLabel(args.pricingModel)
    },
    {
      label: 'Billing frequency',
      value: `${toBillingFrequencyLabel(args.billingFrequency)} / ${
        args.billingType === 'IN_ADVANCE' ? 'In advance' : 'In arrears'
      }`
    },
    ...(args.taxCategoryName
      ? [
          {
            label: 'Tax category',
            value: args.taxCategoryName
          }
        ]
      : []),
    ...(args.revenueRecognitionMethod
      ? [
          {
            label: 'Revenue recognition method',
            value: toRevenueRecognitionMethodLabel(
              args.revenueRecognitionMethod
            )
          }
        ]
      : [])
  ]
}
